import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import skeletonSVG from './assets/version-detail-skeleton.tpl.svg';

export const VersionDetailSkeleton = () => <AppSkeletonImage src={skeletonSVG} />;
